<p-dialog
  #orgSelector
  [(visible)]="orgSelectorVisible"
  [blockScroll]="true"
  [closable]="true"
  [closeOnEscape]="true"
  (visibleChange)="orgSelectorVisibilityChanged($event)"
  [style]="{ width: '850px', height: '700px' }"
  [contentStyle]="{ height: '100%', 'padding-top': 0 }"
  [modal]="true"
  [responsive]="true"
>
  <p-header>
    <span style="font-weight: bold; display: inline-block; padding-left: 8px"
      >Search & Select Organisation</span
    >
  </p-header>
  <div *ngIf="loading; else loaded" class="centered-loading-spinner">
    Please wait...
    <img src="assets/images/loader.gif" alt="Loading" width="35" height="35" />
  </div>
  <ng-template #loaded>
    <div class="d-flex flex-wrap" style="flex-direction: column">
      <div style="height: 75px; position: sticky; top: 0px; background-color: #fff">
        <div class="d-flex flex-wrap" style="padding-top: 10px">
          <div class="flex-grow-1">
            <div style="padding-left: 8px; padding-right: 8px">
              <div class="md-inputfield" style="position: relative">
                <div class="pb-1">Search Organisation</div>
                <input
                  id="orgNameInput"
                  #orgNameInput
                  autofocus
                  (ngModelChange)="searchTextChanged($event)"
                  [ngModel]="searchText"
                  autocomplete="off"
                  class="search-box"
                  name="orgName"
                  pInputText
                  placeholder="Search"
                  spellcheck="false"
                  type="text"
                />
                <span class="fa fa-search search-icon"></span>
              </div>
            </div>
          </div>
          <div class="flex-shrink-1">
            <div class="d-flex flex-wrap">
              <div class="px-2">
                <div class="pb-1">Organisation Type</div>
                <p-dropdown
                  [options]="organisationTypeOptions"
                  (ngModelChange)="organisationTypeChange($event)"
                  [ngModel]="orgType"
                  styleClass="engineius-dropdown"
                ></p-dropdown>
              </div>
              <div class="px-2">
                <div class="pb-1">Organisation Status</div>
                <p-dropdown
                  [options]="organisationStatusOptions"
                  (ngModelChange)="organisationStatusChange($event)"
                  [ngModel]="orgStatus"
                  styleClass="engineius-dropdown"
                ></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="color: rgb(51, 51, 51); flex-grow: 1">
        <div class="px-2">
          <table class="organisation-view" style="width: 100%; font-size: 0.8rem">
            <thead>
              <tr>
                <th style="text-align: left">Supplier</th>
                <th style="text-align: left">Contact Details</th>
                <th style="text-align: left">Organisation</th>
                <th style="text-align: left">Date Created</th>
                <th style="text-align: left">Status</th>
              </tr>
            </thead>
            <tbody>
              <tr
                (click)="organisationSelected(org)"
                *ngFor="let org of organisationInfos; let i = index"
              >
                <td style="text-align: left">
                  <div style="font-weight: bold">{{ org.name }}</div>
                  <div class="sub-row">
                    {{ org.addressLine1 }} {{ org.town }} {{ org.postcode }}
                  </div>
                </td>
                <td>
                  <div class="sub-row"><i class="fa fa-envelope"></i> {{ org.emailAddress }}</div>
                  <div class="sub-row"><i class="fa fa-phone"></i> {{ org.phoneNumber }}</div>
                  <div
                    class="sub-row"
                    *ngFor="let phone of org.organisationPhoneNumbers; let idx = index"
                  >
                    <div *ngIf="idx == 0">
                      <i class="fa fa-phone"></i> {{ phone.phoneNumber }}
                      <span
                        *ngIf="org.organisationPhoneNumbers?.length > 1"
                        (mouseover)="hoverMore = org.id"
                        (mouseout)="hoverMore = null"
                        >+ {{ org.organisationPhoneNumbers.length - 1 }} more</span
                      >
                    </div>

                    <span
                      *ngIf="
                        org.organisationPhoneNumbers && org.organisationPhoneNumbers.length > 1
                      "
                    >
                      <div *ngIf="idx > 0 && hoverMore == org.id">
                        <i class="fa fa-phone-square"></i> {{ phone.phoneNumber }}
                      </div>
                    </span>
                  </div>
                </td>
                <td>
                  {{ org.organisationTypeName }}
                </td>
                <td
                  pTooltip="Organisation Created Date"
                  tooltipStyleClass="xtooltip xtooltip-small"
                  tooltipPosition="top"
                >
                  <span>{{ org.dateCreated | date : "dd MMM 'yy" }}</span>
                </td>
                <td class="org-inactive-{{ org.inactive }}" *ngIf="!org.suspended">
                  <span class="bull-status">&bull;</span>
                  <span class="org-status">{{ orgStatusName[org.inactive] }}</span>
                </td>
                <td *ngIf="org.suspended" pTooltip="Suspended">
                  <span class="bull-status">&bull;</span>
                  <i class="fa fa-warning" style="color: #f97316"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
